module.exports = __webpack_public_path__ + "static/media/gpsp 24.33d59dfa.png";